import React, { useState } from 'react';
import { useLanguage } from '@/App';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getRoute } from '../utils/routes';

const Navbar = () => {
  const { language, toggleLanguage } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Get route helper function
  const getRouteForLanguage = (routeKey) => {
    return getRoute(routeKey, language);
  };

  const content = {
    tr: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      influencer: 'Influencer Kayıt'
    },
    en: {
      home: 'Home',
      about: 'About Us',
      influencer: 'Influencer Signup'
    }
  };

  const t = content[language];

  return (
    <nav className="fixed w-full bg-[#FFDD59] text-black z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_persona-digital-1/artifacts/jvwwfk5v_IST%20DXB.jpg" 
              alt="Persona Agency Logo" 
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Ana Sayfa */}
            <Link 
              to={getRouteForLanguage('home')} 
              className="px-6 py-2 bg-[#FFDD59] text-black font-semibold rounded-lg hover:bg-yellow-400 transition min-w-[160px] text-center"
            >
              {t.home}
            </Link>
            
            {/* Hakkımızda */}
            <Link 
              to={getRouteForLanguage('about')} 
              className="px-6 py-2 bg-[#FFDD59] text-black font-semibold rounded-lg hover:bg-yellow-400 transition min-w-[160px] text-center"
            >
              {t.about}
            </Link>
            
            {/* Influencer Kayıt */}
            <Link 
              to={getRouteForLanguage('influencer')} 
              className="px-6 py-2 bg-[#FFDD59] text-black font-semibold rounded-lg hover:bg-yellow-400 transition min-w-[160px] text-center"
            >
              {t.influencer}
            </Link>
            
            {/* Language Toggle */}
            <button 
              onClick={toggleLanguage}
              className="px-6 py-2 bg-black text-[#FFDD59] font-semibold rounded-lg hover:bg-gray-900 transition min-w-[80px]"
            >
              {language === 'tr' ? 'EN' : 'TR'}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center space-x-4">
            <button 
              onClick={toggleLanguage}
              className="px-3 py-1 bg-black text-[#FFDD59] font-semibold rounded"
            >
              {language === 'tr' ? 'EN' : 'TR'}
            </button>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-[#FFDD59] border-t border-yellow-600">
          <div className="px-4 pt-4 pb-4 space-y-3">
            {/* Ana Sayfa */}
            <Link 
              to={getRouteForLanguage('home')} 
              className="block w-full text-center px-4 py-3 bg-black text-[#FFDD59] rounded-lg hover:bg-gray-900 font-semibold transition" 
              onClick={() => setIsMenuOpen(false)}
            >
              {t.home}
            </Link>
            
            {/* Hakkımızda */}
            <Link 
              to={getRouteForLanguage('about')} 
              className="block w-full text-center px-4 py-3 bg-black text-[#FFDD59] rounded-lg hover:bg-gray-900 font-semibold transition" 
              onClick={() => setIsMenuOpen(false)}
            >
              {t.about}
            </Link>
            
            {/* Influencer Kayıt */}
            <Link 
              to={getRouteForLanguage('influencer')} 
              className="block w-full text-center px-4 py-3 bg-black text-[#FFDD59] rounded-lg hover:bg-gray-900 font-semibold transition" 
              onClick={() => setIsMenuOpen(false)}
            >
              {t.influencer}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
